import { Grid } from '@mui/material'

import InputField from './InputField'

const GridInputField = ({
  label,
  field,
  value,
  onChange = () => {},
  type,
  md = 6,
  mode = 'update',
}) => (
  <Grid size={{ xs: 12, md }}>
    <center>
      <InputField
        label={label}
        value={value}
        onChange={i => onChange(field, type === 'number' ? +i : i)}
        type={type}
        mode={mode}
      />
    </center>
  </Grid>
)

export default GridInputField
